import { render } from "./PageNotFound.vue?vue&type=template&id=68e0138c"
const script = {}
script.render = render

export default script